// @flow

import statusErrors from "../data/statusErrors";

// eslint-disable-next-line import/prefer-default-export
export const displayErrorForStatusCode = (addMessage, statusCode: ?number) =>
  addMessage(statusErrors(statusCode), "failure");
